import PrivateLabelDesignersList from "components/../private-label-designers-list";

export function displayRetailValueCopy(designerId) {
  const privateLabelCopy = "comparable value";
  const externalLabelCopy = "original retail";

  return PrivateLabelDesignersList.some(designer => designer.id === designerId) ? privateLabelCopy : externalLabelCopy;
}

export function asLocalCurrencyString(priceValue, digits = 2) {
  let currency;
  let amount;

  if (Number.isFinite(priceValue)) {
    amount = priceValue;
    currency = "USD";
  } else {
    const [currencyValue, amountValue] = /^(?:([A-Z]+) )?(\d+(?:\.\d+)?)/.exec(priceValue);
    amount = parseFloat(amountValue);
    currency = currencyValue || "USD";
  }

  amount.toLocaleString(void 0, {
    style: "currency",
    currency,
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  });
}

export function getPriceDisplay(price) {
  const { minimum, maximum } = price || {};

  if (!minimum) return "";

  if (minimum === maximum) return asLocalCurrencyString(minimum);

  return `${minimum} - ${maximum}`;
}
